var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useContext } from 'react';
import { LucidDevToolsContext } from './LucidDevToolsContext';
export const useLucidDevTools = () => {
    _react_refresh_temp_1();
    const lucidDevToolsValue = useContext(LucidDevToolsContext);
    if (!lucidDevToolsValue) {
        throw new Error('LucidDevTools context not available!');
    }
    return lucidDevToolsValue;
};
_react_refresh_temp_1(useLucidDevTools, "8IpHCXlLvBWcN+JeCRZDPTYtF1k=");
